import React from 'react';

const Sidebar = ({ activeSection, setActiveSection }) => {
  return (
    <aside className="sidebar">
      <nav>
        <ul>
          <li
            className={activeSection === 'profile' ? 'active' : ''}
            onClick={() => setActiveSection('profile')}
          >
            <i className="bi bi-person-fill"></i> Profile
          </li>
          <li
            className={activeSection === 'classroom' ? 'active' : ''}
            onClick={() => setActiveSection('classroom')}
          >
            <i className="bi bi-house-door-fill"></i> Classroom
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;